import React from "react";
import "./Blog.css";

const Blog = () => {
  return <div>Blogs</div>;
};

export default Blog;
